import * as React from "react";

import { Confirm, CustomDimension } from "./Chapters";

export default (key, method) => {
  switch (key) {
    case "CUSTOM_DIMENSION":
      return <CustomDimension {...{ method }} />;
    default:
      return <Confirm {...{ method }} />;
  }
};
